import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

export enum ToastLevel {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

const DURATION_MS: Record<ToastLevel, number> = {
  [ToastLevel.SUCCESS]: 2500,
  [ToastLevel.WARNING]: 3000,
  [ToastLevel.ERROR]: 4000,
};

const COLOR: Record<ToastLevel, string> = {
  [ToastLevel.SUCCESS]: 'success',
  [ToastLevel.WARNING]: 'warning',
  [ToastLevel.ERROR]: 'danger',
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toastController = inject(ToastController);

  async success(message: string): Promise<void> {
    await this._present(message, ToastLevel.SUCCESS);
  }

  async warning(message: string): Promise<void> {
    await this._present(message, ToastLevel.WARNING);
  }

  async error(message: string): Promise<void> {
    await this._present(message, ToastLevel.ERROR);
  }

  private async _present(message: string, level: ToastLevel): Promise<void> {
    const toast = await this._toastController.create({
      message,
      duration: DURATION_MS[level],
      color: COLOR[level],
      position: 'bottom',
    });
    await toast.present();
  }
}
